import {
  INIT_LOGIN_REQUEST,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  RESET_LOGIN_STATE,
} from "../../actionTypes/login";

export interface LoginState {
  loading: boolean;
  error: string | null;
  message: string;
  success: boolean;
  data?: {
    accessToken?: string;
    refreshToken?: string;
    expiresIn?: number;
    sessionId?: string;
    tokenType?: string;
    activeRole?: string;
    availableRoles?: string[];
  };
}

const initialState: LoginState = {
  loading: false,
  message: "",
  error: null,
  success: false,
};

interface InitLoginAction {
  type: typeof INIT_LOGIN_REQUEST | typeof LOGIN_REQUEST;
}

interface LoginSuccessAction {
  type: typeof LOGIN_SUCCESS;
  payload: {
    message: string;
    data?: {
      accessToken: string;
      refreshToken: string;
      expiresIn: number;
      sessionId: string;
      tokenType: string;
      activeRole?: string;
      availableRoles?: string[];
    };
  };
}

interface LoginFailureAction {
  type: typeof LOGIN_FAILURE;
  payload: string;
}

interface ClearLoginStateAction {
  type: typeof RESET_LOGIN_STATE;
}

export type LoginAction =
  | InitLoginAction
  | LoginSuccessAction
  | LoginFailureAction
  | ClearLoginStateAction;

const loginReducer = (
  state: LoginState = initialState,
  action: LoginAction,
): LoginState => {
  switch (action.type) {
    case INIT_LOGIN_REQUEST:
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        message: action.payload.message,
        success: true,
        data: action.payload.data,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Login failed",
        success: false, // Explicitly set success to false on failure
        message: "",
      };

    case RESET_LOGIN_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loginReducer;
